import {
  Component,
  HostListener, Inject,
  Input,
  OnInit, PLATFORM_ID
} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {Country, EventItem, EventStatus, League, Lookups, Race} from "@model";
import {DatePipe, isPlatformBrowser} from "@angular/common";
import {environment} from "@environment";
import {TranslocoService} from "@ngneat/transloco";
import {EVENT_DETAILS} from "../../app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-event-list-item-big',
  templateUrl: './event-list-item-big.component.html',
  styleUrls: ['./event-list-item-big.component.scss'],
  providers: [DatePipe]
})
export class EventListItemBigComponent extends AbstractComponent implements OnInit {
  @Input() eventItem: EventItem | undefined;
  @Input() league: League | undefined;
  @Input() isLast: boolean = false;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Country[] = [];

  eventCountry: Country | undefined;
  currentWindowWidth: number= 0;
  lengths: (string | undefined)[] = [];
  listSizeBreakpoint: number = environment.eventItemLengthsSizeUiBreakpoint;

  constructor(private datePipe: DatePipe, public translocoService: TranslocoService, private router: Router,
              private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object) {
    super();
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit(): void {
    this.setEventCountry();
    this.setEventLengths();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.currentWindowWidth = event.target.innerWidth;
  }

  checkSameDate(eventItem: EventItem | undefined): boolean {
    if (eventItem?.start && eventItem.end) {
      let startDate: Date = new Date(eventItem.start);
      let endDate: Date = new Date(eventItem.end);
      return (startDate < endDate) && (startDate.getDate() !== endDate.getDate());
    } else {
      return false;
    }
  }

  formatDate(date: Date | string): string {
    const month: string | null = this.datePipe.transform(date, 'MMM');
    return month ? month.slice(0, 3) : '';
  }

  setEventCountry(): void {
    if (this.countries !== null && this.countries.length > 0 && this.eventItem && this.eventItem.country) {
      let country: Lookups | undefined = this.countries.find((item: Lookups) => item.id === this.eventItem!.country);
      if (country) {
        this.eventCountry = country;
      }
    }
  }

  setEventLengths(): void {
    this.lengths = this.eventItem?.lengths && ((this.eventItem?.lengths?.length ?? 0) > 0) ? this.eventItem?.lengths?.slice(0, this.listSizeBreakpoint)
      : Array.from(new Set(this.eventItem?.racesList?.map((race: Race) => race.length?.toString()))).slice(0, this.listSizeBreakpoint);
  }

  openEventDetails(): void {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {eventId: this.eventItem!.id}
    });
  }


  protected readonly EventStatus = EventStatus;
  protected readonly length = length;
  protected readonly environment = environment;
}
